/**
 * Applies the OBR theme to CSS custom properties.
 *
 * OBR does NOT inject any CSS variables of its own — an extension must read
 * OBR.theme.getTheme() and apply the colors itself. The variable NAMES here are
 * ours (the `--dcc-*` namespace); the VALUES come from the official Theme object
 * (docs.owlbear.rodeo/extensions/apis/theme). This is the ecosystem-standard
 * approach and the reason the panel is legible in both light and dark modes.
 */
import type { Theme } from './obrSdk.ts';

export function applyTheme(theme: Theme): void {
  const root = document.documentElement.style;
  root.setProperty('--dcc-text', theme.text.primary);
  root.setProperty('--dcc-text-secondary', theme.text.secondary);
  root.setProperty('--dcc-text-disabled', theme.text.disabled);
  root.setProperty('--dcc-bg', theme.background.default);
  root.setProperty('--dcc-bg-raised', theme.background.paper);
  root.setProperty('--dcc-primary', theme.primary.main);
  root.setProperty('--dcc-primary-contrast', theme.primary.contrastText);
  root.setProperty('--dcc-border', theme.text.disabled);
  root.setProperty('color-scheme', theme.mode === 'DARK' ? 'dark' : 'light');
}
